import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import OfficeLookupActionButtons from '@components/table/actionButtons/OfficeLookupActionButtons';
import DataTable from '../dataTable';
import translateColumns, { translateSort } from '../dataTable/dataTranslate';

const OfficeLookupTable = ({
  displayData,
  onOfficeSelect,
  isModal = false,
}) => {
  const officeSelected = row => onOfficeSelect(row);

  const actionsFormatter = (cell, row) => (
    <OfficeLookupActionButtons
      officeSelected={officeSelected}
      currRow={row}
    />
  );

  const hdrSortClasses = (_column, sortOrder) => `sorting_${sortOrder}`;

  const columns = [
    {
      dataField: 'actions',
      text: 'Actions',
      formatter: actionsFormatter,
      headerStyle: { width: '55px' },
    },
    {
      dataField: 'UniqueID',
      text: 'ID',
      hidden: true,
    },
    {
      dataField: 'OfficeMlsId',
      text: 'MLS ID',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'OfficeName',
      text: 'Office Name',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'OfficePhone',
      text: 'Phone',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: false,
    },
    {
      dataField: 'OfficeAOR',
      text: 'AOR',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: false,
    },
  ];

  const defaultSorted = [{
    dataField: 'OfficeMlsId',
    order: 'desc',
  }];

  const newCols = useMemo(() => translateColumns(columns), [columns]);

  return (
    <DataTable
      defaultSorted={translateSort(defaultSorted)}
      columns={newCols}
      sizePerPage={isModal ? 5 : 10}
      data={displayData}
      wrapperClasses="table-responsive"
      id="officesTable"
      noDataIndication="Your search returned no results. Please try adjusting your search criteria."
      classes="dataTable"
      striped
      hover
    />
  );
};

OfficeLookupTable.propTypes = {
  displayData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onOfficeSelect: PropTypes.func,
  isModal: PropTypes.bool,
};

export default OfficeLookupTable;
